var t,e;function r(){return e?t:(e=1,t=function(t){t.prototype[Symbol.iterator]=function*(){for(let t=this.head;t;t=t.next)yield t.value}})}export{r as __require};
